var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * original html structure (note that extra divs have been inserted by using fela)
 *
 * <div class="cf-select">
 *   <label class="cf-select__label">Label</label>
 *
 *   <div class="Select is-searchable has-value">
 *     <input type="hidden"/>
 *
 *     <div class="Select-control">
 *       <div class="Select-placeholder">Placeholder</div>
 *
 *       <!-- When not searchable: -->
 *       <div class="Select-input" tabindex="0">&nbsp;</div>
 *
 *       <!-- When searchable: -->
 *       <div class="Select-input" style="...">
 *         <input value="" tabindex="0" style="...">
 *         <div style="..."></div>
 *       </div>
 *
 *       <!-- When searchable and has option -->
 *       <span class="Select-clear-zone" title="Clear value" aria-label="Clear value">
 *         <span class="Select-clear">×</span>
 *       </span>
 *
 *       <div class="Select-arrow-zone">
 *         <span class="Select-arrow"></span>
 *       </div>
 *     </div>
 *
 *     <!-- only when open -->
 *     <div class="Select-menu-outer">
 *       <div class="Select-menu">
 *         <div class="Select-option is-selected">One</div>
 *         <div class="Select-option">Two</div>
 *         <div class="Select-option is-focused">Three</div>
 *       </div>
 *     </div>
 *
 *   </div>
 * </div>
 */

import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect, { AsyncCreatable, Async, Creatable } from 'react-select';
import { createComponent } from '@cloudflare/style-container';
import Value from './Value';
import Option from './Option';
import MenuHeader from './MenuHeader';
import CloseMenu from './CloseMenu';
import menuRenderer from './menuRenderer';
import arrowRenderer from './arrowRenderer';
import clearRenderer from './clearRenderer';
import { sendEvent, ConnectEventTracking } from '@cloudflare/util-user-tracking';

var Label = createComponent(function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'block',
    fontSize: '0.7em',
    color: theme.colors.gray[4],
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    marginBottom: '0.5em'
  };
}, 'label');
Label.setDisplayName('Label');

// bindRight is used to ensure that menuRenderer, called from within react-select,
// is always passed a second parameter which is used for further configuration.
var bindRight = function bindRight(fn) {
  for (var _len = arguments.length, rightArgs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rightArgs[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return fn.apply(undefined, args.concat(rightArgs));
  };
};

var Select = function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select(props) {
    _classCallCheck(this, Select);

    var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

    _this.menuRenderer = bindRight(props.menuRenderer, {
      menuTitle: props.menuTitle,
      menuHeaderComponent: props.menuHeaderComponent,
      closeMenuComponent: props.closeMenuComponent,
      closeMenu: function closeMenu() {
        var nested = props.creatable || props.async;
        var select = nested ? _this.select.select : _this.select;
        select && select.closeMenu();
      }
    });
    return _this;
  }

  _createClass(Select, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          async = _props.async,
          creatable = _props.creatable,
          searchable = _props.searchable,
          label = _props.label,
          className = _props.className,
          multi = _props.multi,
          clearable = _props.clearable,
          onChange = _props.onChange,
          props = _objectWithoutProperties(_props, ['async', 'creatable', 'searchable', 'label', 'className', 'multi', 'clearable', 'onChange']);

      var SelectClass = void 0;
      if (async) {
        SelectClass = creatable ? AsyncCreatable : Async;
      } else {
        SelectClass = creatable ? Creatable : ReactSelect;
      }
      return React.createElement(
        'div',
        { className: '' + className },
        label && React.createElement(
          Label,
          null,
          label
        ),
        React.createElement(
          ConnectEventTracking,
          null,
          function (_ref2) {
            var category = _ref2.category;

            var handleChange = function handleChange(e) {
              // If analytics info has been specified, send an event
              // Sometimes these events can be undefined so check for that
              var valueLabel = e && e.label;
              if (category && valueLabel) {
                sendEvent({
                  category: category,
                  action: 'Clicked on ' + valueLabel,
                  label: 'Select Value Click'
                });
              }

              if (onChange) {
                onChange(e);
              }
            };
            return React.createElement(SelectClass, _extends({}, props, {
              onChange: handleChange,
              searchable: searchable,
              clearable: searchable || creatable || multi || clearable,
              backspaceRemoves: searchable || creatable,
              menuRenderer: _this2.menuRenderer,
              ref: function ref(_ref3) {
                return _this2.select = _ref3;
              },
              multi: multi
            }));
          }
        )
      );
    }
  }]);

  return Select;
}(React.Component);

Select.defaultProps = {
  multi: false,
  searchable: false,
  async: false,
  creatable: false,
  clearable: false,
  disabled: false,
  menuRenderer: menuRenderer,
  arrowRenderer: arrowRenderer,
  clearRenderer: clearRenderer,
  optionComponent: Option,
  valueComponent: Value,
  menuHeaderComponent: MenuHeader,
  closeMenuComponent: CloseMenu
};

Select.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.any,
  options: PropTypes.array,
  searchable: PropTypes.bool,
  multi: PropTypes.bool,
  onChange: PropTypes.func,
  async: PropTypes.bool,
  creatable: PropTypes.bool,
  menuRenderer: PropTypes.func,
  arrowRenderer: PropTypes.func,
  clearRenderer: PropTypes.func,
  isValidNewOption: PropTypes.func,
  noResultsText: PropTypes.string,
  promptTextCreator: PropTypes.func,
  newOptionCreator: PropTypes.func,
  menuTitle: PropTypes.string,
  menuHeaderComponent: PropTypes.func,
  closeMenuComponent: PropTypes.func,
  loadOptions: PropTypes.func,
  autoload: PropTypes.bool,
  searchPromptText: PropTypes.string,
  cache: PropTypes.bool,
  clearable: PropTypes.bool,
  placeholder: PropTypes.string
};

var singleOrPlaceholder = function singleOrPlaceholder(theme) {
  return {
    bottom: 0,
    color: theme.colors.gray[1],
    left: 0,
    lineHeight: '32px',
    paddingLeft: '10px',
    paddingRight: '10px',
    position: 'absolute',
    right: 0,
    top: 0,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
};

var styles = function styles(_ref4) {
  var theme = _ref4.theme,
      disabled = _ref4.disabled;

  var values = {
    boxSizing: 'border-box',
    fontSize: '0.86667rem'
  };

  return _extends({}, values, {
    '& div': values,
    '& input': values,
    '& span': values,

    flex: theme.flex,
    margin: theme.margin,
    width: theme.width,
    display: theme.display,
    verticalAlign: theme.verticalAlign,
    position: 'relative',
    textAlign: 'left',

    '& .Select-control': {
      backgroundColor: disabled ? theme.colors.gray[8] : theme.colors.white,
      border: '1px solid ' + theme.colors.gray[5],
      borderRadius: theme.borderRadius,
      color: theme.colors.gray[1],
      cursor: 'default',
      display: 'table',
      borderSpacing: 0,
      borderCollapse: 'separate',
      height: '32px',
      outline: 'none',
      overflow: 'hidden',
      position: 'relative',
      width: '100%',
      transition: 'border-color 0.2s ease',
      opacity: disabled ? 0.5 : 1
    },
    '& .Select-control .Select-input:focus': {
      outline: 'none'
    },
    '& .Select-menu-outer': {
      position: 'relative'
    },
    '&:hover .Select-control': {
      borderColor: disabled ? theme.colors.gray[5] : theme.colors.blue[4]
    },
    '& .is-focused .Select-control': {
      borderColor: theme.colors.blue[3]
    },
    '& .is-open .Select-control': {
      borderColor: theme.colors.gray[5]
    },
    '& .Select-placeholder': singleOrPlaceholder(theme),
    '& .is-focused.is-searchable .Select-placeholder': {
      display: 'none'
    },
    '& .Select--single > .Select-control .Select-value': singleOrPlaceholder(theme),
    '& .Select-input': {
      height: '32px',
      verticalAlign: 'middle'
    },
    '& .Select-input > input': {
      width: '100%',
      background: 'none transparent',
      border: ' 0 none',
      cursor: 'default',
      display: 'inline-block',
      fontFamily: 'inherit',
      fontSize: 'inherit',
      marginLeft: '10px',
      marginRight: '10px',
      marginTop: 0,
      marginBottom: 0,
      outline: 'none',
      lineHeight: '14px',
      padding: 0
    },
    '& .Select-noresults': {
      boxVizing: 'border-box',
      color: theme.colors.gray[4],
      cursor: 'default',
      display: 'block',
      padding: '8px 10px'
    },
    '& .Select-aria-only': {
      display: 'inline-block',
      height: '1px',
      width: '1px',
      margin: '-1px',
      clip: 'rect(0, 0, 0, 0)',
      overflow: 'hidden'
    },
    '& .Select-arrow-zone': {
      cursor: disabled ? 'default' : 'pointer',
      display: 'table-cell',
      position: 'relative',
      textAlign: 'center',
      verticalAlign: 'middle',
      width: '25px',
      paddingRight: '5px',
      top: '1px',
      pointerEvents: 'none'
    },
    '& .Select-clear-zone': {
      color: theme.colors.gray[4],
      cursor: ' pointer',
      display: 'table-cell',
      position: 'relative',
      top: '1px',
      textAlign: 'center',
      verticalAlign: 'middle',
      width: '17px'
    }
  });
};
Select.displayName = 'Select';
export default createComponent(styles, Select);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-select/es/Select.js
// module id = 1105
// module chunks = 1